import { Color } from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import type { CamelCasedPropertiesDeep } from 'type-fest';

import { ProductsListResponse } from './api/ProductPayWallApi';

export type PlanPreview = {
  totalDueToday: string;
  renewalDate: string;
  recurringAmount: string;
};

export type ProductPlanSelectedItem = number;

export type ProductPlan = {
  id: ProductPlanSelectedItem;
  label: string;
  descriptions: string[];
};

export type BannerType = Color;

export type ProductsList = CamelCasedPropertiesDeep<ProductsListResponse>;
export type ProductsListItem = ProductsList[number];

export type ProductBanner = {
  message: string;
  type: BannerType;
};

export type ProductData = {
  banner?: ProductBanner;
  plans: ProductPlan[];
  value: ProductPlanSelectedItem | null;
};

export const Product = {
  HCPAssist: 'hcp_assist',
  Voice: 'voice',
  Payroll: 'payroll',
  HCPLite: 'invoices_lite_basic',
  Accounting: 'accounting',
};
